<div class="empty-state-container">
  <p class="empty-state-message">{{ displayMessage() }}</p>
</div>
